export const googleRecaptchaFormatActionName = (action: string) => action.replace(/[^a-zA-Z_]/g, "_");
